export default "__VITE_ASSET__Bo7sKe1i__"